
<div class="card text-center">
  <div class="card-header">
    {{ 'CANCELPATIENTVISIT' | translate }} / {{translate.currentLang == 'ar'? patVisit.fullnameAr : patVisit.fullnameEn}}
  </div>

  <div class="card-block">
    <div class="row">  
      <div class="col-sm-2">
        <div class="form-group">
          <sanabel-selectize appcode="36" [(ngModel)]="patVisit.cancelReason">
          </sanabel-selectize>
        </div>
      </div>
      <div class="col-sm-10">
        <label for="notes">{{ 'NOTES' | translate }}</label>
        <textarea class="form-control" rows="4" id="notes" [(ngModel)]="patVisit.dischargeRemarks" name="dischargeRemarks"></textarea>
      </div>
    </div>
    <div class="container-fluid">
      <div class="row">

        <div class="col" *ngIf="msgDataToggle">
          <btns-ctrl [appCodes]="[1]" (clicked)="onClicked($event)"></btns-ctrl>
        </div>
      </div>
    </div>
  </div>
</div>



